"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fs = require("fs");
var FileLoaderNodeJS = /** @class */ (function () {
    function FileLoaderNodeJS() {
    }
    FileLoaderNodeJS.prototype.LoadFile = function (FileName, bIsCryptoFile) {
        return fs.readFileSync(FileName).toString();
    };
    FileLoaderNodeJS.prototype.FileExist = function (FileName, bIsCryptoFile) {
        return fs.existsSync(FileName);
    };
    FileLoaderNodeJS.prototype.getAbsolutePath = function (FileName) {
        return FileName;
    };
    FileLoaderNodeJS.prototype.getIncludeFilePath = function (sPath, bIsCryptoFile) {
        throw new Error("Method not implemented.");
    };
    return FileLoaderNodeJS;
}());
exports.default = FileLoaderNodeJS;

//# sourceMappingURL=FileLoaderNodeJS.js.map
